import $ from 'jquery';
import PubSub from 'Utils/pub-sub';

const KEY = {
    ENTER: 13
};

export default class Search {

  constructor($el) {
    this.root = $el;
    this.searchToggle = $el.find('.js-search_toggle');
    this.searchField = $el.find('.js-search_field');
    this.searchLabel = $el.find('.js-search_label');
    this.isAlwaysOpen = this.root.hasClass('is-open');

    //
    this.handleEvents();
  }

  handleEvents() {
    this.searchField.click(e => e.stopPropagation());


    this.searchField.keydown(e => {
      e.stopPropagation();
      this.handleKeyDown(e);
    });

    this.searchToggle.click(e => {
      e.preventDefault();

      if (this.isAlwaysOpen) {
          if (this.searchField.val() !== "" && this.searchField.val() !== null) {
              this.submitMainSearchField(this.searchField);
          }
        return;
      }

      if (this.searchField.val() !== "" && this.searchField.val() !== null) {
          this.submitMainSearchField(this.searchField);
      }

      this.root.toggleClass('is-open');
      PubSub.publish('login-search:toggle');

      setTimeout(() => {
        window.addEventListener('click', this.onOutsideClick(this));
      });
    });
  }

  submitMainSearchField(element) {
      var keywordField = $('<input type="hidden" name="keyword">');
      var value = element.val();
      keywordField.val(btoa(value).replace(/=/g, ''));
      element.prop('disabled', true);
      element.closest('form').append(keywordField).submit();
  }

  handleKeyDown(e) {
      e.stopPropagation();

      if ((e.keyCode) == KEY.ENTER){
          e.preventDefault();
          if (this.searchField.val() !== "" && this.searchField.val() !== null) {
              this.submitMainSearchField(this.searchField);
          }
      }
  }

  onOutsideClick(self) {
    return function unBindOutsideClick() {
      self.root.toggleClass('is-open');

      PubSub.publish('login-search:toggle');

      window.removeEventListener('click', unBindOutsideClick); 
    }
  }

  isSearchFieldEmpty(value) {
    return value === "";
  }
}


// WEBPACK FOOTER //
// ./src/components/search-field/search.js